import { useRoles } from "hooks";
import React from "react";
import { Form } from "react-bootstrap";

const ActionItemVerificationField = ({
  isVerified,
  isLoading,
  verifyActionItem,
}) => {
  const { isAdmin } = useRoles();
  if (!isAdmin) return <></>;

  return (
    <Form.Group
      controlId="isVerified"
      className="d-flex gap-2 align-items-center"
    >
      <Form.Label className="mb-0">Verified</Form.Label>
      <Form.Check
        onChange={verifyActionItem}
        name="isVerified"
        defaultChecked={isVerified}
      />
      {isLoading && (
        <output className="spinner-border spinner-border-sm">
          <span className="visually-hidden">Loading...</span>
        </output>
      )}
    </Form.Group>
  );
};

export default ActionItemVerificationField;
